<template>
  <nav id="mynav" class="nav-breadcrumb">
    <ul class="nav-BreadcrumbList">
      <li class="nav-BreadcrumbItem" v-for="(item, index) in navData" :key="index">
        <a :href="item.url" v-if="item.url">
          <span>{{  item.text }}</span>
        </a>
        <strong v-else>{{ item.text }}</strong>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'MyNav',
  props: {
    navData: {
      type: Array,
      default: 
        () => {
          return []
        }
    }
  },
  data() {
    return {}
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/MyNav.vue